module.exports = __webpack_public_path__ + "img/tr.ce2e2e8e.svg";